import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { memo } from 'react';
import { ReportContentWrapper } from '../components/ReportContent';
import {
  ReportScreenProps,
  useReportContext,
} from '../components/ReportContext';
import { PreInspectionReportView } from '../components/pre-inspection/PreInspectionReportView';
import { PreInspectionReportViewIpad } from '../components/pre-inspection/PreInspectionReportView.iPad';

const Content = memo((props: ReportScreenProps) => {
  const { report } = useReportContext();
  const isMobile = useIsMobileLayout();

  if (!isMobile) {
    return <PreInspectionReportViewIpad report={report} />;
  }

  return (
    <PreInspectionReportView report={report} standalone={props.standalone} />
  );
});

export const PreInspectionReportScreen = wrapNavigatorScreen(
  ({ title, ...props }: ReportScreenProps) => {
    const isMobile = useIsMobileLayout();
    return (
      <ReportContentWrapper
        tab="preInspection"
        title={title ?? '预检报告'}
        shouldUseLandscapeLayout={!isMobile}
        {...props}
      >
        <Content {...props} />
      </ReportContentWrapper>
    );
  },
  {
    headerShown: false,
    title: '预检报告',
  },
);
